import { useSelector } from 'react-redux';

import { MenuItem } from '@atlassian/bitbucket-navigation';

import { ComponentLinkProxy } from 'src/components/component-link';
import { ContainerNavigationProps } from 'src/components/navigation/src/components/container-navigation-v3';
import { useHistory__UNSAFE, useLocation, useMatch } from 'src/router/hooks';
import {
  getMenuItems,
  getSelectedMenuItem,
} from 'src/selectors/project-selectors';
import { BucketState } from 'src/types/state';
import { publishUiEvent } from 'src/utils/analytics/publish';

export const useProjectNavigationProps = (): ContainerNavigationProps => {
  const history = useHistory__UNSAFE();
  const location = useLocation();
  const match = useMatch();
  const menuItems = useSelector(getMenuItems);
  const selectedMenuItem = useSelector<BucketState, MenuItem | undefined>(
    state => getSelectedMenuItem(state, location.pathname, match.url)
  );

  return {
    menuItems,
    selectedMenuItem,
    linkComponent: ComponentLinkProxy,
    history,
    publishUiEvent,
  };
};
